/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_Col_DesiInputs */

const tr_katalog_desi_page_col_desi = /** @type {(inputs: Katalog_Desi_Page_Col_DesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi`)
};

const en_katalog_desi_page_col_desi = /** @type {(inputs: Katalog_Desi_Page_Col_DesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi`)
};

const de_katalog_desi_page_col_desi = /** @type {(inputs: Katalog_Desi_Page_Col_DesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desi`)
};

const ru_katalog_desi_page_col_desi = /** @type {(inputs: Katalog_Desi_Page_Col_DesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Деси`)
};

/**
* | output |
* | --- |
* | "Desi" |
*
* @param {Katalog_Desi_Page_Col_DesiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_col_desi = /** @type {((inputs?: Katalog_Desi_Page_Col_DesiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_Col_DesiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_col_desi(inputs)
	if (locale === "de") return de_katalog_desi_page_col_desi(inputs)
	if (locale === "ru") return ru_katalog_desi_page_col_desi(inputs)
	return tr_katalog_desi_page_col_desi(inputs)
});